<script setup lang="ts">
import { ref, watch } from 'vue'

import { Button, PopoverMenu, Tooltip } from '@collector/shared-ui'
import { IncidentId } from '@collector/sportsapi-client-legacy'
import { useEventIncidentsQueue } from '@desktop/views/Relation/Sports/composables'
import { injectPocketIncidentsConfig } from '@desktop/views/Relation/Sports/provide-inject'

interface Props {
  disabled?: boolean
}

const props = defineProps<Props>()

// composables
const eventIncidentsQueue = useEventIncidentsQueue()

// inject
const { morePocketIncidents } = injectPocketIncidentsConfig()

// state
const isPopoverMenuOpened = ref(false)

// data
const popoverMenuOptions = morePocketIncidents?.map(
  ({ incidentId, title }) => ({
    name: title,
    value: incidentId,
  }),
)

// watch
watch(
  () => props.disabled,
  (disabled) => {
    if (disabled) {
      isPopoverMenuOpened.value = false
    }
  },
)

// methods
function sendIncident(incidentId: IncidentId): void {
  eventIncidentsQueue.addIncident(
    {
      incident_id: incidentId,
    },
    { shouldResetPossession: true },
  )
}
</script>

<template>
  <PopoverMenu
    v-if="popoverMenuOptions"
    v-model="isPopoverMenuOpened"
    :options="popoverMenuOptions"
    :content="{
      align: 'end',
    }"
    @clickOption="sendIncident"
  >
    <template #trigger>
      <Tooltip lazy>
        <template #tooltip>More pocket incidents</template>
        <Button
          class="enabled:hover:bg-neutral-light-0 cursor-pointer rounded-sm border-none disabled:cursor-default"
          square
          size="sm"
          icon="ellipsis-vertical"
          :disabled
          data-testid="pocket-incident-button"
        />
      </Tooltip>
    </template>
  </PopoverMenu>
</template>
